// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"SkipButton_buttonContainer__efZII"};